module.exports = __webpack_public_path__ + "static/media/img1-2.3271663f.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/cebolla/nutricheck_foliar/FE/img1-2.png
// module id = 1376
// module chunks = 3